/**
 * Build a Google Maps search URL that opens in the browser (or app on mobile).
 *
 * @param {object | null | undefined} address - e.g. business `BusinessAddress`
 * @param {string} [address.AddressLine1]
 * @param {string} [address.AddressLine2]
 * @param {string} [address.City]
 * @param {string} [address.State]
 * @param {string} [address.PostalCode]
 * @param {string} [address.ZipCode]
 * @param {string} [address.Zip]
 * @param {boolean} [address.ShowAddressToPublic]
 * @returns {string | null} URL or null if there is nothing to search
 */
export function buildGoogleMapsSearchUrl(address) {
  if (!address || typeof address !== 'object') return null;
  if (address.ShowAddressToPublic === false) return null;

  const zip = address.PostalCode ?? address.ZipCode ?? address.Zip;
  const parts = [
    address.AddressLine1,
    address.AddressLine2,
    address.City,
    address.State,
    zip,
  ]
    .map((x) => (x == null ? '' : String(x).trim()))
    .filter(Boolean);
  if (parts.length === 0) return null;
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(parts.join(', '))}`;
}
